import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type InvoiceMarkAsPaidParams = {
  id: string;
};

export const invoiceMarkAsPaidAtom = createMutationAtomFactory(
  'finance.invoiceMarkAsPaid',
  (params: InvoiceMarkAsPaidParams) => ({
    financeInvoiceMarkAsPaid: {
      __args: {
        id: params.id,
      },
      id: true,
      documentNumber: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
